module.exports = __webpack_public_path__ + "media/images/social-logos/whatsapp-ebe7508a8513ca92a14d27189b5546ce.svg";